// SignInTile.tsx — a Today tile inviting the user to sign in or create a free
// account (part of the in-app onboarding). Shown only when activation is on and
// the user is signed out. A free account keeps your progress safe and lets you
// explore much of the programme; membership unlocks everything. Presents all
// four sign-in methods via the shared AccountSignIn panel.
import { Card, Display, Body } from '@/components/ui';
import { AccountSignIn } from '@/components/AccountSignIn';

export function SignInTile() {
  return (
    <Card level={2} glow pad={16}>
      <div
        style={{
          fontFamily: 'Inter, system-ui, sans-serif',
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: 'var(--amber-deep)',
          marginBottom: 6,
        }}
      >
        Welcome
      </div>
      <Display parts={{ pre: 'Sign in to ', em: 'begin', post: '.' }} size={18} lh={1.2} />
      <Body size={14} style={{ marginTop: 7, lineHeight: 1.55 }}>
        Create a free account to keep your progress safe and explore much of the programme.
      </Body>
      <div style={{ marginTop: 13 }}>
        <AccountSignIn compact />
      </div>
    </Card>
  );
}
